// Time Entries V2 specific dropdown options
// These use null for "All" to match the API requirements

export const timeEntriesStatusOptions = [
  { label: 'All', value: null },
  { label: 'Invoiced', value: 'INVOICED' },
  { label: 'Uninvoiced', value: 'OPEN' },
];

export const timeEntriesBillingOptions = [
  { label: 'All', value: null },
  { label: 'Billable', value: 'billable' },
  { label: 'Non-Billable', value: 'nonbillable' },
];
